import React, { Component } from 'react';

import {
  Link,
  withRouter
} from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';





import Site, {SiteModifier_,withSite} from '../utils/Site'
import Each from '../utils/Each'

import Base from '../components/BaseComponent'
import Intro from '../components/Intro'
import Item from '../components/Item'
import Content from '../components/Content'
import Grid from '../components/Grid'
import Media from '../components/Media'
import Newsletter from '../components/Newsletter'
import Button from '../components/Button'
import Banners from '../components/Banners'
import Image from '../components/Image'
import FadeIn from '../components/FadeIn'
import Slider from '../components/Slider'
import Icon from '../components/Icon'
import Welcome from '../components/Welcome';
import ActionLogger from '../components/ActionLogger';
import Window from '../utils/Window';
import Related from '../components/Related';
import Tidy from '../components/Tidy';
import ScrollTo from '../components/ScrollTo';



import Asset from '../models/Asset'
import Entry from '../models/Entry'

require('../helpers/Array.js');


class COMPONENT extends Component {



	constructor(props) {
		super(props);
		this.state = {index:0, transitioned: 0 }
	}

	componentDidMount() {
	}

	componentWillUnmount() {

	}

	handleScroll = (e) => {
		if(e.target.scrollTop == 0)
		{
			this.props.site.deModify('open');
		}
		//console.log(e.target.scrollTop,window.innerHeight)
	}

	transitionEnd = () => {

      this.setState({transitioned:this.cur});

  }

  updateIndex = () => {
			this.setState({index:this.state.index+1})
  }

  shouldComponentUpdate = (nextProps) => {

  		return this.props.location.pathname != nextProps.location.pathname;

  }

  getVideoId = (entry) => {
  	if(entry.video && entry.video.length) {
  		return entry.video[0]
  	}
  	else {
  		return null
  	}
  }

	/*

		RENDER

	*/

	render() {

		const {entry} = this.props;
		//console.log('entry',entry);

		let slides = entry.carousel


		return (
			<FadeIn>
			<ScrollTo pos={0}/>
			<div className="Site-welcome">
          		<Welcome />
        	</div>
			<div className="Template  Template--home">

					{/* Template-head */}
					<div className="Template-head">

						{/* Template-intro */}
						<Window className="Template-intro">

							<Slider autoplay={true} delay={5000}>
								{entry.carousel.shuffle().map((item,ix) => (
										<Entry id={item.slide} render={ (slide) => (
										<Item modifiers={['intro']}>


												<Entry id={slide.related} render={ (link) => (
												<Link to={link.uri}>
												<div className="Item-head">
													<div className="Item-title">
														<Content modifier={'yellow'}>
															<Tidy html={'<h1>'+slide.title+'<h1>'}/>
														</Content>
													</div>
													<div className="Item-subTitle">
														<Content>
															<h4>{(slide.sponsered) ? 'Sponsored' : slide.subtitle}</h4>
														</Content>
													</div>
												</div>
												</Link>
												) } />

												<div className="Item-media">
													<Media id={slide.image[0]} videoId={this.getVideoId(slide)} />
												</div>


										</Item>
										)} />

								))}
							</Slider>

						</Window>
						{/* / Template-intro */}

					</div>
					{/* / Template-head */}

					{/* Template-body */}
					<div className="Template-body">



						<div className="Template-sections">

							{/* Template-section */}
							<div className="Template-section  Template-section--full  Template-section--mobileFlush  Template-section--first">

								<div className="Template-heading">
									<Content html="<h1>I want to</h1>" />
								</div>

								<div className="Template-content">

									<Grid modifiers={['4','tiles']} >

										<Each items={entry.iWantTo} render={

												(item) => (

													<div className="Grid-item">
														<Item modifiers={['square']} >
															<Entry id={item.blockLink} render={ (link) => (
															<Link to={link.uri + (item.display == 'list' ? '#list':'')}>
																<div className="Item-head"><div className="Content"><h2>{item.blockTitle}</h2></div></div>

																<div className="Item-media">
																	<Media id={item.image[0]} />
																</div>
															</Link>
															)} />
														</Item>
													</div>

											)} />

									</Grid>

								</div>

							</div>
							{/* / Template-section */}

							{/* Template-section */}
							<div className="Template-section  Template-section--full">

								<div className="Template-content">
									<Grid modifiers={['2','tiles']} >

									<Each items={entry.sections[0].feature} render={

										(item) => (

										<div className="Grid-item">
											<Item modifiers={['feature']}>
												<Entry id={item.featureLink} render={ (link) => (
												<Link to={link.uri}>

													<div className="Item-head">
														<div className="Item-title">
															<Content modifier={'yellow'}>
																<h2>{item.featureTitle}</h2>
															</Content>
														</div>
														<div className="Item-subTitle">
															<Content>
																<h4>{item.subtitle}</h4>
															</Content>
														</div>
													</div>

													<div className="Item-media">

														<Media id={item.image[0]} />

													</div>

												</Link>
												)} />
											</Item>
										</div>
									)}/>

									</Grid>
								</div>
							</div>
							{/* / Template-section */}

							{/* Template-section */}
							<div className="Template-section  Template-section--full  Template-section--container">
								<div className="Template-heading">
									<Content modifier={"home"}>
										<h1>Speak up!</h1>
										<p>Tell us who you are and get free stuff</p>
									</Content>
								</div>
								<div className="Template-content">
									<Newsletter />
								</div>
							</div>
							{/* / Template-section */}

							{/* Template-section */}
							<div className="Template-section  Template-section--full  Template-section--container">

								<div className="Template-content">
										<Entry id={entry.sections[2].buttons} results={

										(items) => (items.shuffle().limit(1).map(
											(item) => (
											<ActionLogger category="Promotion" action="Big Button Click" label={item.title + ' button press from '+this.props.location.pathname}>
												<Button entry={item} format="vertical" />
											</ActionLogger>
											))

										)}/>
								</div>

							</div>


							{/* Template-section */}
							<div className="Template-section  Template-section--full  Template-section--social">

								<div className="Template-heading">
									<Content modifier={'alt'}>
										<h1>Be Social</h1>
									</Content>
								</div>

								<div className="Template-content">

										<Banners entry={entry}/>
								</div>

							</div>
							{/* / Template-section */}

							{/* Template-section */}
							<div className="Template-section  Template-section--full  Template-section--radio  Template-section--container">

								<div className="Template-heading">
									<Content modifier={'alt'}>
										<h1>Be loud</h1>
									</Content>
								</div>

								<div className="Template-content">

									<div className="Template-content-container">

									<Item modifiers={['radio']}>
											<a href={'https://open.spotify.com/user/39r98nky23rqc88llk032cz1e/playlist/1axRkWOHLMfNQT2KvZYPs0'} target="_blank">
												<div className="Item-container">
													<div className="Item-head">
														<Content modifier={'radio'} ><h1>Fenway Fm</h1></Content>
													</div>

													<div className="Item-body">
														<ul className="List  List--radioIcons">
															<li><Icon type={'arrow-right-black'} /></li>
															<li><Icon type={'spotify-black'} /></li>
															<li><Icon type={'arrow-left-black'} /></li>
														</ul>

													</div>

													<div className="Item-foot">
														<Content modifier={'radio'}><h4>Press for vibes</h4></Content>
													</div>

												</div>
											</a>
									</Item>

									</div>

								</div>

							</div>
							{/* / Template-section */}

							{/* Template-section */}
							<div className="Template-section  Template-section--full Template-section--logos">

								<div className="Template-heading">
									<Content modifier={'alt'}>
										<h1>We love these guys</h1>
									</Content>
								</div>

								<div className="Template-content ">

										<Grid modifiers={['6']} >

										<Entry id={entry.sections[4].logos} results={

												(items) => (

														<Each items={items} render={ (item) => {

														if(item.related && item.related.length) {

															return (
																<div className="Grid-item">
																<Entry id={[item.related[0]]} render={
																	(rel) => (
																	<Item modifiers={['logo']}>
																		<Link to={rel.uri}>
																			<div className="Item-media">
																				<Media id={item.image[0]} original={true} fluid={true} />
																			</div>
																		</Link>
																	</Item>
																)}/>

																</div>
															)
														} else {
															return (
																<div className="Grid-item">

																	<Item modifiers={['logo']}>
																			<div className="Item-media">
																				<Media id={item.image[0]} original={true} fluid={true} />
																			</div>
																	</Item>


																</div>)
															
														}
														}}/>
												)
										}/>


										</Grid>

								</div>

							</div>
							{/* / Template-section */}

							<Related to={entry} modifier={'home'} />


						</div>


					</div>
					{/* / Template-body */}

			</div>
			</FadeIn>
		);

	}
}

export default withRouter(withSite(COMPONENT));



// WEBPACK FOOTER //
// ./src/js/templates/Home.js